import React, { useState, useEffect } from 'react';
import alanBtn from '@alan-ai/alan-sdk-web'
import NewsCards from './components/NewsCards/NewsCards';
import useStyle from './styles.js';

import './App.css';


const alankey = 'c6f5ddb7a08e21aee378049a6e9dbbd72e956eca572e1d8b807a3e2338fdd0dc/stage';

const App = () => {

  const [newsArticles, setNewsArticles] = useState([]);
  const classes = useStyle();

  useEffect(() => {
    alanBtn({
      key: alankey,
      onCommand: ({ command, articles }) => {
        if(command === 'newHeadlines') {
          setNewsArticles(articles);
        }
      }
    })
  }, [])


  return (
    <div>
      <div className={classes.logoContainer}>
      <img src="https://alan.app/voice/images/previews/preview.jpg"  className={classes.alanLogo} alt="alan-logo"/>
      </div>
      <NewsCards articles={newsArticles} />
    </div>
  )
}

export default App;
